//Action Types
export var VETS_RESET_ACTION_TYPE = "vets/reset";
export var VETS_FETCH_START_ACTION_TYPE = "vets/fetch_start";
export var VETS_FETCH_SUCCESS_ACTION_TYPE = "vets/fetch_success";
export var VETS_GET_START_ACTION_TYPE = "vets/get_start";
export var VETS_GET_SUCCESS_ACTION_TYPE = "vets/get_success";
export var VETS_SAVE_START_ACTION_TYPE = "vets/save_start";
export var VETS_SAVE_SUCCESS_ACTION_TYPE = "vets/save_success";
export var VETS_ERROR_ACTION_TYPE = "vets/error";
